(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gifty-search-filters"] && !Shopify.designMode) return;
  try {
    if (!window.giftySearchValidationBound) {
  window.giftySearchValidationBound = true;
  document.addEventListener('input', (event) => {
    const panel = event.target.closest('.gf-filters');
    if (!panel) return;
    const maximum = panel.querySelector('[name="filter.v.price.lte"]');
    if (maximum) maximum.setCustomValidity('');
    const message = panel.querySelector('.gf-filters__error');
    if (message) { message.hidden = true; message.textContent = ''; }
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    const panel = form.querySelector('.gf-filters');
    if (!panel) return;
    const minimum = panel.querySelector('[name="filter.v.price.gte"]');
    const maximum = panel.querySelector('[name="filter.v.price.lte"]');
    if (minimum && maximum && minimum.value !== '' && maximum.value !== '' && Number(minimum.value) > Number(maximum.value)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      panel.open = true;
      maximum.setCustomValidity(panel.dataset.rangeError);
      const message = panel.querySelector('.gf-filters__error');
      message.textContent = panel.dataset.rangeError;
      message.hidden = false;
      maximum.focus();
      maximum.reportValidity();
      return;
    }
    const query = form.querySelector('[name="q"]');
    if (query && !query.value.trim()) query.value = '*';
  }, true);
}
  } catch(e) { console.error(e); }
})();

})();
